<template>
    <div class="aliados">
        <center><h1>Nuestros aliados</h1></center>
        <center>
            <VueSlickCarousel v-bind="settings">
                    <div v-for="(aliado, i) in aliados" :key="i" class="aliados-home">
                        <img :src="aliado.image" alt="" class="aliado-img">
                    </div>
            </VueSlickCarousel>
        </center>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'aliadosHome',
    components: {
        VueSlickCarousel
    },
    data() {
        return {
            aliados: [
                {
                    id: 'slide1',
                    image: require('@/assets/aliados/seguros-aseguradora-solidaria.png')
                },
                {
                    id: 'slide2',
                    image: require('@/assets/aliados/seguros-axa-colpatria.png')
                },
                {
                    id: 'slide3',
                    image: require('@/assets/aliados/seguros-bmi.png')
                },
                {
                    id: 'slide4',
                    image: require('@/assets/aliados/seguros-bolivar.png')
                },
                {
                    id: 'slide5',
                    image: require('@/assets/aliados/seguros-bsb.png')
                },
                {
                    id: 'slide7',
                    image: require('@/assets/aliados/seguros-colmena.png')
                },
                {
                    id: 'slide8',
                    image: require('@/assets/aliados/seguros-del-estado.png')
                },
                {
                    id: 'slide9',
                    image: require('@/assets/aliados/seguros-global.png')
                },
                {
                    id: 'slide11',
                    image: require('@/assets/aliados/seguros-sura.png')
                },
                {
                    id: 'slide12',
                    image: require('@/assets/aliados/seguros-zurich.png')
                }
            ],
            settings: {
                'dots': false,
                'focusOnSelect': true,
                'infinite': true,
                'speed': 500,
                'slidesToShow': 4,
                'slidesToScroll': 1,
                'touchThreshold': 5,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'responsive': [
                    {
                        'breakpoint': 1000,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 600,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'initialSlide': 2
                        }
                    },
                    {
                        'breakpoint': 480,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1
                        }
                    }
                ]
            }
        }
    }
}
</script>

<style>
.aliados > .slick-slider > .slick-list  {
    width: 80%;
}
</style>

<style scoped>
.aliados {
    padding-top: 100px;
    padding-left: 50px;
    padding-right: 50px;
}

.aliados-home > .aliado-img{
    margin-top: 25px;
    margin-bottom: 25px;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
}

.aliados > center > h1 {
    font-family: 'jbd';
    color: #2d4f98;
    margin-bottom: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/utilitis/aliados.vue